import { perScreenMediaSchema } from './media';
export const playgroundMediaSchema = perScreenMediaSchema('PlaygroundMedia');
//# sourceMappingURL=playground-media.js.map